module.exports = __webpack_public_path__ + "040fec325963c2f0668a51f18493ac2d.jpg";